import { render, staticRenderFns } from "./ClaimHistory.vue?vue&type=template&id=9d11029c&"
import script from "./ClaimHistory.vue?vue&type=script&lang=js&"
export * from "./ClaimHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports